import { css } from "@emotion/react";

import { transition } from "@styles/emotion-styles/animations";

export const accordion = css`
  ${transition("margin-bottom")}

  > button {
    padding: 0;

    > div,
    > div > div {
      flex: 1 0 100%;
      align-items: center;
    }
  }

  > button + div > div {
    padding: 0;
    padding-left: 1.25rem;
    padding-bottom: 0.125rem;
  }
`;

export const accordionOpen = css`
  margin-bottom: 1rem;
`;

export const ingredientHeader = css`
  flex: 1;
  align-items: center;
`;

export const childIngredients = css`
  padding-left: 0.65rem;
`;
